module.exports = __webpack_public_path__ + "4cda21fb4fcb2fe1d78df2d4b7852dd2.jpg";